<template>
	<NuxtLayout>
		<NuxtPage />

		<AfxConsentBanner />
	</NuxtLayout>
</template>

<script setup lang="ts">
import AfxConsentBanner from '@/components/afx-consent/AfxConsentBanner.vue'
import { useAfxStore } from '@/stores/afx'

const afxStore = useAfxStore()
onMounted(() => afxStore.syncBannerFromCookie())
</script>
